<div class="content">
  <rt-requisitions-activities-container />
</div>
